import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _040ed5fd = () => interopDefault(import('..\\pages\\error.vue' /* webpackChunkName: "pages_error" */))
const _11578208 = () => interopDefault(import('..\\pages\\errors\\index.vue' /* webpackChunkName: "pages_errors_index" */))
const _3fddaca8 = () => interopDefault(import('..\\pages\\not-eligible.vue' /* webpackChunkName: "pages_not-eligible" */))
const _7441eb38 = () => interopDefault(import('..\\pages\\success.vue' /* webpackChunkName: "pages_success" */))
const _097abe31 = () => interopDefault(import('..\\pages\\thank-you.vue' /* webpackChunkName: "pages_thank-you" */))
const _28a733c2 = () => interopDefault(import('..\\pages\\unlock.vue' /* webpackChunkName: "pages_unlock" */))
const _6e4bbd9b = () => interopDefault(import('..\\pages\\upload-documents\\index.vue' /* webpackChunkName: "pages_upload-documents_index" */))
const _0c452b86 = () => interopDefault(import('..\\pages\\upload-documents-success.vue' /* webpackChunkName: "pages_upload-documents-success" */))
const _a4ca67e8 = () => interopDefault(import('..\\pages\\upload-documents\\success.vue' /* webpackChunkName: "pages_upload-documents_success" */))
const _1ded8e3c = () => interopDefault(import('..\\pages\\errors\\404.vue' /* webpackChunkName: "pages_errors_404" */))
const _d3883394 = () => interopDefault(import('..\\pages\\hcp\\diagnosis-information.vue' /* webpackChunkName: "pages_hcp_diagnosis-information" */))
const _725f871a = () => interopDefault(import('..\\pages\\hcp\\eligibility.vue' /* webpackChunkName: "pages_hcp_eligibility" */))
const _2b9dfb5e = () => interopDefault(import('..\\pages\\hcp\\getting-started.vue' /* webpackChunkName: "pages_hcp_getting-started" */))
const _35034992 = () => interopDefault(import('..\\pages\\hcp\\health-insurance-information.vue' /* webpackChunkName: "pages_hcp_health-insurance-information" */))
const _eeba0c6c = () => interopDefault(import('..\\pages\\hcp\\patient-information.vue' /* webpackChunkName: "pages_hcp_patient-information" */))
const _47ac039c = () => interopDefault(import('..\\pages\\hcp\\pharmacy-information.vue' /* webpackChunkName: "pages_hcp_pharmacy-information" */))
const _d3514de4 = () => interopDefault(import('..\\pages\\hcp\\prescriber-information.vue' /* webpackChunkName: "pages_hcp_prescriber-information" */))
const _630ef62e = () => interopDefault(import('..\\pages\\hcp\\success.vue' /* webpackChunkName: "pages_hcp_success" */))
const _422a50c3 = () => interopDefault(import('..\\pages\\patient\\eligibility.vue' /* webpackChunkName: "pages_patient_eligibility" */))
const _64c60532 = () => interopDefault(import('..\\pages\\patient\\patient-authorization.vue' /* webpackChunkName: "pages_patient_patient-authorization" */))
const _bcfb52c6 = () => interopDefault(import('..\\pages\\patient\\patient-authorization-success.vue' /* webpackChunkName: "pages_patient_patient-authorization-success" */))
const _8fe883cc = () => interopDefault(import('..\\pages\\patient\\patient-information.vue' /* webpackChunkName: "pages_patient_patient-information" */))
const _b1a71a84 = () => interopDefault(import('..\\pages\\patient\\prescriber-information.vue' /* webpackChunkName: "pages_patient_prescriber-information" */))
const _02b99f2f = () => interopDefault(import('..\\pages\\pharmacy\\eligibility.vue' /* webpackChunkName: "pages_pharmacy_eligibility" */))
const _cc78cd6e = () => interopDefault(import('..\\pages\\pharmacy\\ncpdp.vue' /* webpackChunkName: "pages_pharmacy_ncpdp" */))
const _3343965a = () => interopDefault(import('..\\pages\\pharmacy\\patient-authorization.vue' /* webpackChunkName: "pages_pharmacy_patient-authorization" */))
const _3f683ef4 = () => interopDefault(import('..\\pages\\pharmacy\\patient-information.vue' /* webpackChunkName: "pages_pharmacy_patient-information" */))
const _b2dbae5c = () => interopDefault(import('..\\pages\\pharmacy\\prescriber-information.vue' /* webpackChunkName: "pages_pharmacy_prescriber-information" */))
const _7f6e9072 = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages_index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('#{BasePath}#/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/error",
    component: _040ed5fd,
    name: "error"
  }, {
    path: "/errors",
    component: _11578208,
    name: "errors"
  }, {
    path: "/not-eligible",
    component: _3fddaca8,
    name: "not-eligible"
  }, {
    path: "/success",
    component: _7441eb38,
    name: "success"
  }, {
    path: "/thank-you",
    component: _097abe31,
    name: "thank-you"
  }, {
    path: "/unlock",
    component: _28a733c2,
    name: "unlock"
  }, {
    path: "/upload-documents",
    component: _6e4bbd9b,
    name: "upload-documents"
  }, {
    path: "/upload-documents-success",
    component: _0c452b86,
    children: [{
      path: "",
      component: _a4ca67e8,
      name: "upload-documents-success"
    }]
  }, {
    path: "/errors/404",
    component: _1ded8e3c,
    name: "errors-404"
  }, {
    path: "/hcp/diagnosis-information",
    component: _d3883394,
    name: "hcp-diagnosis-information"
  }, {
    path: "/hcp/eligibility",
    component: _725f871a,
    name: "hcp-eligibility"
  }, {
    path: "/hcp/getting-started",
    component: _2b9dfb5e,
    name: "hcp-getting-started"
  }, {
    path: "/hcp/health-insurance-information",
    component: _35034992,
    name: "hcp-health-insurance-information"
  }, {
    path: "/hcp/patient-information",
    component: _eeba0c6c,
    name: "hcp-patient-information"
  }, {
    path: "/hcp/pharmacy-information",
    component: _47ac039c,
    name: "hcp-pharmacy-information"
  }, {
    path: "/hcp/prescriber-information",
    component: _d3514de4,
    name: "hcp-prescriber-information"
  }, {
    path: "/hcp/success",
    component: _630ef62e,
    name: "hcp-success"
  }, {
    path: "/patient/eligibility",
    component: _422a50c3,
    name: "patient-eligibility"
  }, {
    path: "/patient/patient-authorization",
    component: _64c60532,
    name: "patient-patient-authorization"
  }, {
    path: "/patient/patient-authorization-success",
    component: _bcfb52c6,
    name: "patient-patient-authorization-success"
  }, {
    path: "/patient/patient-information",
    component: _8fe883cc,
    name: "patient-patient-information"
  }, {
    path: "/patient/prescriber-information",
    component: _b1a71a84,
    name: "patient-prescriber-information"
  }, {
    path: "/pharmacy/eligibility",
    component: _02b99f2f,
    name: "pharmacy-eligibility"
  }, {
    path: "/pharmacy/ncpdp",
    component: _cc78cd6e,
    name: "pharmacy-ncpdp"
  }, {
    path: "/pharmacy/patient-authorization",
    component: _3343965a,
    name: "pharmacy-patient-authorization"
  }, {
    path: "/pharmacy/patient-information",
    component: _3f683ef4,
    name: "pharmacy-patient-information"
  }, {
    path: "/pharmacy/prescriber-information",
    component: _b2dbae5c,
    name: "pharmacy-prescriber-information"
  }, {
    path: "/",
    component: _7f6e9072,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
